import React from 'react';
import { FadeIn, Section, SectionLabel, ButtonSecondary, ButtonPrimary } from './UI';
export const OfferSection = () => {
  const checkoutUrl = 'https://inkovacreation.store/shop/0de4a31b-dafb-4911-b0f5-64f146eb7e48';
  return <>
      <Section id="cta" className="bg-brand-grayBg" data-id="element-59">
        <FadeIn data-id="element-60">
          <SectionLabel data-id="element-61">Lo que obtienes hoy</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-62">
            Todo incluido.
            <br data-id="element-63" />
            <span className="text-brand-purple" data-id="element-64">Un solo precio.</span>
          </h2>

          <div className="text-center mt-7" data-id="element-65">
            <div className="font-serif text-[4rem] text-brand-purple font-black leading-none" data-id="element-66">
              $33
            </div>
            <p className="text-[0.9rem] text-[#666] mt-2" data-id="element-67">
              Pago único · Acceso inmediato · Sin suscripción
            </p>
          </div>

          <div className="text-center mt-9" data-id="element-68">
            <ButtonSecondary text="👉 Descargar Mi Guía Ahora — $33" href={checkoutUrl} data-id="element-69" />
            <p className="mt-[14px] text-[0.85rem] text-[#888]" data-id="element-70">
              Descarga directa · PDF · Sin complicaciones
            </p>
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-brand-purple text-brand-white text-center" data-id="element-71">
        <FadeIn data-id="element-72">
          <span className="text-[4rem] mb-5 block" data-id="element-73">🛡️</span>
          <SectionLabel className="!text-brand-pink text-center" data-id="element-74">
            Sin riesgos
          </SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-white mb-5 font-bold" data-id="element-75">
            Tu inversión está protegida.
          </h2>
          <p className="text-white/85 max-w-[540px] mx-auto mb-3 text-[1.05rem]" data-id="element-76">
            Si descargas la guía y sientes que no te dio claridad sobre el
            proceso de crear tu empresa en USA — escríbenos y lo resolvemos.
            Queremos que avances, no que desperdicies tu dinero.
          </p>
        </FadeIn>
      </Section>

      <Section className="bg-white" data-id="element-77">
        <FadeIn data-id="element-78">
          <SectionLabel data-id="element-79">Quién hay detrás</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-80">
            Creada por
            <br data-id="element-81" />
            <span className="text-brand-purple" data-id="element-82">@inkovacreation</span>
          </h2>

          <div className="flex flex-col sm:flex-row gap-7 items-start bg-brand-grayBg rounded-[20px] p-9 mt-7 border-l-[6px] border-brand-purple" data-id="element-83">
            <div className="w-[90px] h-[90px] rounded-full bg-brand-purple flex items-center justify-center text-[2.5rem] shrink-0" data-id="element-84">
              🏢
            </div>
            <div data-id="element-85">
              <h3 className="font-serif text-[1.4rem] text-brand-purple mb-[10px] font-bold" data-id="element-86">
                Inkova LLC
              </h3>
              <p className="text-[0.97rem] mb-2" data-id="element-87">
                En Inkova hemos acompañado a decenas de emprendedores latinos a
                crear su empresa en USA con orden, estructura y presencia
                digital — sin perderse en el camino.
              </p>
              <p className="text-[0.97rem] mb-2" data-id="element-88">
                Esta guía es el destilado de todo ese proceso, para que tú
                puedas avanzar por tu cuenta con la misma claridad que tienen
                nuestros clientes de consultoría.
              </p>
              <p className="text-brand-purple font-semibold text-[0.97rem]" data-id="element-89">
                ¿Prefieres hacerlo con acompañamiento? Con gusto te ayudamos a
                completar todo el proceso correctamente.
              </p>
            </div>
          </div>
        </FadeIn>
      </Section>

      <section className="bg-brand-purple text-brand-white text-center py-[100px] px-6" data-id="element-90">
        <FadeIn className="max-w-[800px] mx-auto" data-id="element-91">
          <h2 className="font-serif text-[clamp(2rem,5vw,3.2rem)] leading-[1.2] text-brand-white max-w-[680px] mx-auto mb-5 font-bold" data-id="element-92">
            Cada día que pasa
            <br data-id="element-93" />
            <span className="text-brand-pink" data-id="element-94">tu competencia avanza.</span>
          </h2>
          <p className="text-white/80 max-w-[480px] mx-auto mb-10 text-[1.05rem]" data-id="element-95">
            Tu idea merece una empresa real detrás. Ruta USA 360 te da el mapa.
            Tú pones la acción.
          </p>

          <ButtonPrimary text="👉 Descargar Mi Guía — $33" href={checkoutUrl} data-id="element-96" />

          <a href="https://wa.me/17863037695" className="block mt-6 text-white/70 text-[0.95rem] no-underline hover:text-brand-pink transition-colors" data-id="element-97">
            ¿Tienes dudas? Escríbenos por WhatsApp →
          </a>
        </FadeIn>
      </section>
    </>;
};